import { useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export default function LeadForm({ qrId, ownerId }) { 
  console.log("OWNER ID:", ownerId);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [targetUrl, setTargetUrl] = useState("");

  // 1. Fetch destination URL with safety checks
const [qrUUID, setQrUUID] = useState("");

useEffect(() => {
  async function getQRData() {
    const { data, error } = await supabase
      .from("qr_codes")
      .select("id, destination_url")
      .eq("code", qrId)
      .maybeSingle();
    if (error) console.error("Supabase Error:", error.message);
    if (!data) console.error("No record found in DB for code:", qrId);
    if (data) {
      setQrUUID(data.id);
      setTargetUrl(data.destination_url);
    }
  }
  getQRData();
}, [qrId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    console.log("Submitting Lead:", {
    qrId,
    ownerId,
    name,
    email,
    phone
  });
    // Validation: Ensure phone is captured
    if (!phone) {
      alert("Please enter a valid phone number");
      return;
    }

    setLoading(true);

    try {
      // 2. INSERT into 'leads' table
      // Ensure 'full_name', 'email', and 'phone' are the column names in Supabase
      const { error } = await supabase
  .from("qr_leads") 
  .insert([{
    qr_id: qrUUID,    // ← correct UUID
    name: name,
    email: email,
    phone: phone 
  }]);

      if (error) throw error;
      
      setSubmitted(true);
// ADD after the successful supabase insert in handleSubmit:
// Fire notification (non-blocking)
fetch("/api/notify-lead", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    qr_id: qrUUID,
    lead_name: name,
    lead_email: email,
    lead_phone: phone,
    qr_name: ""
  })
});
      // 3. SUCCESS REDIRECT
      setTimeout(() => {
        const finalUrl = targetUrl || "/";
        window.location.replace(finalUrl);
      }, 2000);

    } catch (err) {
      console.error("Critical Submission Error:", err);
      
      // FAIL-FORWARD: If the DB save fails, we still redirect the customer 
      // so the business doesn't lose a potential sale/visit.
      if (targetUrl) {
         window.location.replace(targetUrl);
      } else {
         alert("Technical error. Redirecting...");
         window.location.replace("/");
      }
    } finally {
      setLoading(false);
    }
  };

  if (submitted) return (
    <div className="p-10 text-center text-white font-bold bg-green-600/20 rounded-3xl border border-green-500/50 backdrop-blur-md">
      <div className="text-2xl mb-2 italic uppercase">Details Verified</div>
      <span className="text-sm font-normal opacity-70">Taking you to your destination...</span>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#020617] flex flex-col items-center justify-center p-4">
      {/* ✅ FIXED: Changed <code> to <style> so CSS actually applies */}
      <style>{`.PhoneInputInput { background-color: rgba(255,255,255,0.05) !important; color: white !important; padding: 1.25rem !important; border-radius: 0 0.75rem 0.75rem 0 !important; border: 1px solid rgba(255,255,255,0.1) !important; border-left: none !important; outline: none !important; font-size: 16px !important; } .PhoneInputCountry { background: rgba(255,255,255,0.05); padding: 0 12px; border-radius: 0.75rem 0 0 0.75rem; border: 1px solid rgba(255,255,255,0.1); } .PhoneInputInput:focus { border-color: #3b82f6 !important; }`}</style>
      
      <form onSubmit={handleSubmit} className="space-y-5 w-full max-w-md bg-slate-900/50 p-8 rounded-3xl border border-white/10">
         <div className="text-center mb-8 ">
           <h2 className="text-white text-xl font-black uppercase italic tracking-widest ">Unlock Content </h2 >
           <p className="text-gray-500 text-[10px] uppercase tracking-[5px] mt-1 ">Please verify your identity </p >
         </div >

         <div >
           <label className="text-[10px] font-black uppercase text-gray-500 ml-1 mb-1 block ">Full Name </label >
           <input required placeholder="Enter your name" className="w-full p-4 bg-white/5 border border-white/10 rounded-xl text-white outline-none focus:border-blue-500 transition-all" value={name} onChange={(e) => setName(e.target.value)} />
         </div >

         <div >
           <label className="text-[10px] font-black uppercase text-gray-500 ml-1 mb-1 block ">Email Address </label >
           <input required type="email" placeholder="name@company.com" className="w-full p-4 bg-white/5 border border-white/10 rounded-xl text-white outline-none focus:border-blue-500 transition-all" value={email} onChange={(e) => setEmail(e.target.value)} />
         </div >

         <div >
           <label className="text-[10px] font-black uppercase text-gray-500 ml-1 mb-1 block ">WhatsApp / Phone </label >
           <PhoneInput international defaultCountry="IN" value={phone} onChange={setPhone} required />
         </div >

         <button disabled={loading} className={`w-full p-5 mt-4 rounded-2xl text-white font-black uppercase tracking-[3px] shadow-2xl transition-all ${loading ? "bg-gray-800 cursor-not-allowed " : "bg-blue-600 hover:bg-blue-500 active:scale-95 hover:shadow-blue-500/20 "}`}>
          {loading ? "Verifying... " : "Access Now "}
         </button >
     </form >
     </div >
  );
}